import { FUNDER_OWNER_PLANS } from './funderRulesByPlan';
import { INSTITUTION_OWNER_PLANS } from './institutionRulesByPlan';
import { SERVICE_PROVIDER_OWNER_PLANS } from './serviceProviderRulesByPlan';

const fullAdminRoutes: string[] = [
  '/service-provider/programme-stats:visit',

  // My activities
  '/my-activities:visit',
  '/my-activities/:activityId/sessions/:visit',
  '/my-activities/:activityId/sessions/create:visit',
  '/my-activities/:activityId/sessions/:sessionId:visit',

  '/admin/my-profile:visit',
  '/funder/insights:visit',
  '/funder/insights/:insightType/:insightId:visit',
  '/admin/insights:visit',
  '/admin/insights/:insightType/:insightId:visit',
  '/service-provider/insights:visit',
  '/service-provider/insights/:insightType/:insightId:visit',
  '/service-provider/my-profile:visit',
  '/service-provider/exports:visit',
  '/service-provider/manage:visit',

  '/service-provider:visit',
  '/service-provider/manage/institutions:visit',
  '/service-provider/manage/institutions/sites:visit',
  '/service-provider/manage/institutions/sites/hierarchies:visit',
  '/service-provider/manage/institutions/sites/hierarchies/:hierarchyId:visit',
  '/service-provider/manage/institutions/sites/hierarchies/create:visit',
  '/service-provider/manage/institutions/sites/services:visit',
  '/service-provider/manage/institutions/sites/services/:serviceId:visit',
  '/service-provider/manage/institutions/sites/services/create:visit',
  '/service-provider/manage/institutions/create:visit',
  '/service-provider/manage/institutions/:institutionId:visit',

  // SP permitted routes
  `/funder/manage/service-providers/:visit`,
  `/funder/manage/service-providers/create-new:visit`,
  `/funder/manage/service-providers/:serviceProviderId:visit`,

  // Team member permitted routes
  `/service-provider/team-members/:stakeholderId/activities/:activityId/sessions:visit`,
  `/service-provider/team-members/:stakeholderId/activities/:activityId/sessions/create:visit`,
  `/service-provider/team-members/:stakeholderId/activities/:activityId/sessions/:sessionId:visit`,

  '/service-provider/manage/people:visit',
  '/service-provider/manage/people/create:visit',
  '/service-provider/manage/people/addnew:visit',
  '/service-provider/manage/people/:personId:visit',
  '/service-provider/programmes/portfolios:visit',
  '/service-provider/programmes/:programmeId/sites:visit',
  '/service-provider/programmes/:programmeId/reporters:visit',
  '/service-provider/programmes/:programmeId/reporters/:reporterId/assignees:visit',
  '/service-provider/programmes/:programmeId/reporters/:reporterId/assignees:visit',

  '/service-provider/programmes:visit',
  '/service-provider/programmes/create:visit',
  '/service-provider/programmes/:programmeId/overview:visit',
  '/service-provider/programmes/:programmeId/indicators:visit',
  '/service-provider/programmes/:programmeId/monitoring:visit',
  '/service-provider/programmes/:programmeId/complete:visit',
  '/service-provider/programmes/interventions:visit',
  '/service-provider/programmes/interventions/create:visit',
  '/service-provider/programmes/interventions/:interventionId/overview:visit',
  '/service-provider/programmes/interventions/:interventionId/indicators:visit',
  '/service-provider/programmes/interventions/:interventionId/inputs:visit',
  '/service-provider/programmes/interventions/:interventionId/activities:visit',
  '/service-provider/programmes/interventions/:interventionId/monitoring:visit',
  '/service-provider/programmes/interventions/:interventionId/complete:visit',
  '/service-provider/programmes/interventions/:interventionId/reporters:visit',
  '/service-provider/programmes/interventions/:interventionId/reporters/:reporterId/assignees:visit',
  '/service-provider/manage/templates:visit',
  '/service-provider/manage/templates/create-new:visit',
  '/service-provider/manage/templates/:templateId:visit',
  `/service-provider/manage/insights:visit`,
  `/service-provider/manage/insights/create-new:visit`,
  `/service-provider/manage/insights/:insightId:visit`,
  `/service-provider/manage/insights/:insightId/users:visit`,
  '/service-provider/tasks:visit',
  '/service-provider/exports:visit',
  '/service-provider/exports/:workspaceId/questions:visit',
  '/service-provider/exports/:workspaceId/questions/:type/:typeId:visit',
  '/service-provider/exports/profile-data:visit',
  '/service-provider/exports/school-data:visit',
  '/service-provider/exports/programme-stats:visit',
  '/service-provider/reports:visit',
  '/service-provider/reports/create-link:visit',
  '/service-provider/reports/create-report:visit',
  '/service-provider/reports/create-template:visit',
  '/service-provider/reports/:reportId:visit',

  '/service-provider/reports/templates:visit',
  '/service-provider/reports/create-template:visit',
  '/service-provider/reports/templates/:templateId:visit',

  '/service-provider/activities/activity/:activityId:visit',
  '/service-provider/activities/:stakeholderId:edit',
  'session:status:DRAFT:set',
  'session:status:WAITING_FOR_REVIEW:set',
  'session:status:FLAGGED:set',
  'session:status:APPROVED:set',
  '/service-provider/activities/:activityId/attendees/:visit',
  'activity-session:approve',

  // funder routes
  '/funder:visit',
  '/funder/manage:visit',
  `/funder/manage/service-providers/:visit`,
  `/funder/manage/service-providers/create-new:visit`,
  `/funder/manage/service-providers/:serviceProviderId:visit`,
  '/funder/manage/templates:visit',
  '/funder/manage/templates/create-new:visit',
  '/funder/manage/templates/:templateId:visit',
  '/funder/exports:visit',
  '/funder/exports/:workspaceId/questions:visit',
  '/funder/exports/:workspaceId/questions/:type/:typeId:visit',
  '/funder/exports/profile-data:visit',
  '/funder/exports/school-data:visit',
  '/funder/exports/programme-stats:visit',
  '/funder/programmes/portfolios:visit',
  '/funder/programmes/:programmeId/sites:visit',
  '/funder/programmes/:programmeId/reporters:visit',
  '/funder/programmes/:programmeId/reporters/:reporterId/assignees:visit',
  '/funder/programmes:visit',
  '/funder/programmes/create:visit',
  '/funder/programmes/:programmeId/overview:visit',
  '/funder/programmes/:programmeId/indicators:visit',
  '/funder/programmes/:programmeId/monitoring:visit',
  '/funder/programmes/:programmeId/complete:visit',
  '/funder/programmes/interventions:visit',
  '/funder/programmes/interventions/create:visit',
  '/funder/programmes/interventions/:interventionId/overview:visit',
  '/funder/programmes/interventions/:interventionId/indicators:visit',
  '/funder/programmes/interventions/:interventionId/inputs:visit',
  '/funder/programmes/interventions/:interventionId/activities:visit',
  '/funder/programmes/interventions/:interventionId/monitoring:visit',
  '/funder/programmes/interventions/:interventionId/complete:visit',
  '/funder/programmes/interventions/:interventionId/reporters:visit',
  '/funder/programmes/interventions/:interventionId/reporters/:reporterId/assignees:visit',
  '/funder/reports:visit',
  // '/funder/reports/create:visit',
  '/funder/reports/create-link:visit',
  '/funder/reports/create-report:visit',
  '/funder/reports/create-template:visit',
  '/funder/reports/:reportId:visit',
  `/funder/manage/insights:visit`,
  `/funder/manage/insights/create-new:visit`,
  `/funder/manage/insights/:insightId:visit`,
  `/funder/manage/insights/:insightId/users:visit`,
  '/funder/manage/admin:visit',
  '/funder/manage/admin/create-new:visit',
  '/funder/manage/admin/:workspaceId:visit',
  '/funder/manage/admin/:workspaceId/overview:visit',
  '/funder/manage/admin/:workspaceId/forms/create-new:visit',
  '/funder/manage/admin/:workspaceId/forms/:formId:visit',

  // team member routes
  `/funder/team-members:visit`,
  `/funder/team-members/create-new:visit`,
  `/funder/team-members/:teamMemberId:visit`,

  // admin routes
  '/admin:visit',
  '/admin/school-attendance-data:visit',
  '/admin/school-subject-report:visit',
  '/admin/school-progression-data:visit',
  '/admin/test-performance:visit',
  '/admin/nsc-subjects:visit',
  '/admin/nsc-progression:visit',
  '/admin/manage:visit',
  '/admin/interventions:visit',
  '/admin/data-upload:visit',
  // Data Tools management (IB-1802). Every admin route is gated on a matching ':visit' rule;
  // without one the route renders nothing at all, sidebar included.
  '/admin/data-tools:visit',
  // Permissions are matched by exact string, so every section path is listed rather than
  // relying on the ':section' pattern - the sidebar checks each sub-item's own path.
  '/admin/data-tools/:section:visit',
  '/admin/data-tools/assets:visit',
  '/admin/data-tools/templates:visit',
  '/admin/data-tools/blueprints:visit',
  '/admin/data-tools/rule-sets:visit',
  '/admin/data-tools/reference-datasets:visit',
  '/admin/school-enrolment-data:visit',
  '/admin/school-promotion-data:visit',
  '/admin/school-educators:visit',

  // admin institutions
  `/admin/institutions:visit`,
  `/admin/institutions/create:visit`,
  `/admin/institutions/:institutionId:visit`,
  // admin institutions team members
  `/admin/institutions/:institutionId/team-members:visit`,
  `/admin/institutions/:institutionId/team-members/create-new:visit`,
  `/admin/institutions/:institutionId/team-members/:teamMemberId:visit`,

  // admin people
  `/admin/manage/people:visit`,
  `/admin/manage/people/create:visit`,
  `/admin/manage/people/:personId:visit`,

  // admin team members
  `/admin/team-members:visit`,
  `/admin/team-members/create-new:visit`,
  `/admin/team-members/:teamMemberId:visit`,

  // admin templates
  `/admin/templates:visit`,
  `/admin/templates/create-new:visit`,
  `/admin/templates/:templateId:visit`,

  // admin declarations
  `/admin/declarations:visit`,
  `/admin/declarations/create-new:visit`,
  `/admin/declarations/:declarationId:visit`,

  // admin service providers
  `/admin/service-providers:visit`,
  `/admin/service-providers/create-new:visit`,
  `/admin/service-providers/:serviceProviderId:visit`,

  // admin funder team members
  `/admin/service-providers/:serviceProviderId/team-members:visit`,
  `/admin/service-providers/:serviceProviderId/team-members/create-new:visit`,
  `/admin/service-providers/:serviceProviderId/team-members/:teamMemberId:visit`,

  // admin funders
  `/admin/funders:visit`,
  `/admin/funders/create-new:visit`,
  `/admin/funders/:funderId:visit`,

  // admin funder team members
  `/admin/funders/:funderId/team-members:visit`,
  `/admin/funders/:funderId/team-members/create-new:visit`,
  `/admin/funders/:funderId/team-members/:teamMemberId:visit`,

  // admin Insights
  `/admin/manage/insights:visit`,
  `/admin/manage/insights/create-new:visit`,
  `/admin/manage/insights/:insightId:visit`,
  `/admin/manage/insights/:insightId/users:visit`,

  // admin Audit Trail
  `/admin/auditTrail:visit`,

  // portal owner routes
  ...FUNDER_OWNER_PLANS['ENTERPRISE'].static,
  ...INSTITUTION_OWNER_PLANS['ENTERPRISE'].static,
  ...SERVICE_PROVIDER_OWNER_PLANS['ENTERPRISE'].static,
];

const fullSuperAdminRoutes: string[] = [
  '/admin/my-profile:visit',
  '/service-provider/insights:visit',
  '/service-provider/insights/:insightType/:insightId:visit',
  '/service-provider/my-profile:visit',
  '/funder/insights:visit',
  '/funder/insights/:insightType/:insightId:visit',
  '/admin/insights:visit',
  '/admin/insights/:insightType/:insightId:visit',
  // Data Tools management (IB-1802). Every admin route is gated on a matching ':visit' rule;
  // without one the route renders nothing at all, sidebar included.
  '/admin/data-tools:visit',
  // Permissions are matched by exact string, so every section path is listed rather than
  // relying on the ':section' pattern - the sidebar checks each sub-item's own path.
  '/admin/data-tools/:section:visit',
  '/admin/data-tools/assets:visit',
  '/admin/data-tools/templates:visit',
  '/admin/data-tools/blueprints:visit',
  '/admin/data-tools/rule-sets:visit',
  '/admin/data-tools/reference-datasets:visit',

  'posts:list',
  'posts:create',
  'users:getSelf',
  'home-page:visit',
  'dashboard-page:visit',

  '/service-provider:visit',
  `/service-provider/manage/insights:visit`,
  `/service-provider/manage/insights/create-new:visit`,
  `/service-provider/manage/insights/:insightId:visit`,
  `/service-provider/manage/insights/:insightId/users:visit`,
  '/service-provider/manage/institutions:visit',
  '/service-provider/manage/institutions/sites:visit',
  '/service-provider/manage/institutions/sites/hierarchies:visit',
  '/service-provider/manage/institutions/sites/hierarchies/:hierarchyId:visit',
  '/service-provider/manage/institutions/sites/hierarchies/create:visit',
  '/service-provider/manage/institutions/sites/services:visit',
  '/service-provider/manage/institutions/sites/services/:serviceId:visit',
  '/service-provider/manage/institutions/sites/services/create:visit',
  '/service-provider/manage/institutions/create:visit',
  '/service-provider/manage/institutions/:institutionId:visit',
  // Team member permitted routes
  `/service-provider/team-members/:stakeholderId/activities/:activityId/sessions:visit`,
  `/service-provider/team-members/:stakeholderId/activities/:activityId/sessions/create:visit`,
  `/service-provider/team-members/:stakeholderId/activities/:activityId/sessions/:sessionId:visit`,

  '/service-provider/manage/people:visit',
  '/service-provider/manage/people/create:visit',
  '/service-provider/manage/people/addnew:visit',
  '/service-provider/manage/people/:personId:visit',
  '/service-provider/manage/templates:visit',
  '/service-provider/manage/templates/create-new:visit',
  '/service-provider/manage/templates/:templateId:visit',
  '/service-provider/tasks:visit',
  '/service-provider/exports:visit',
  '/service-provider/exports/:workspaceId/questions:visit',
  '/service-provider/exports/:workspaceId/questions/:type/:typeId:visit',
  '/service-provider/exports/profile-data:visit',
  '/service-provider/exports/school-data:visit',
  '/service-provider/exports/programme-stats:visit',
  '/service-provider/reports:visit',
  '/service-provider/reports/create-link:visit',
  '/service-provider/reports/create-report:visit',
  '/service-provider/reports/create-template:visit',
  '/service-provider/reports/:reportId:visit',
  '/service-provider/programmes/portfolios:visit',
  '/service-provider/programmes/:programmeId/sites:visit',
  '/service-provider/programmes/:programmeId/reporters:visit',
  '/service-provider/programmes/:programmeId/reporters/:reporterId/assignees:visit',
  '/service-provider/programmes:visit',
  '/service-provider/programmes/create:visit',
  '/service-provider/programmes/:programmeId/overview:visit',
  '/service-provider/programmes/:programmeId/indicators:visit',
  '/service-provider/programmes/:programmeId/monitoring:visit',
  '/service-provider/programmes/:programmeId/complete:visit',
  '/service-provider/programmes/interventions:visit',
  '/service-provider/programmes/interventions/create:visit',
  '/service-provider/programmes/interventions/:interventionId/overview:visit',
  '/service-provider/programmes/interventions/:interventionId/indicators:visit',
  '/service-provider/programmes/interventions/:interventionId/inputs:visit',
  '/service-provider/programmes/interventions/:interventionId/activities:visit',
  '/service-provider/programmes/interventions/:interventionId/monitoring:visit',
  '/service-provider/programmes/interventions/:interventionId/complete:visit',
  '/service-provider/activities/:stakeholderId:edit',
  '/service-provider/admin:visit',
  'session:status:DRAFT:set',
  'session:status:WAITING_FOR_REVIEW:set',
  'session:status:FLAGGED:set',
  'session:status:APPROVED:set',

  // funder routes
  '/funder:visit',
  '/funder/manage:visit',
  '/funder/programmes/:programmeId/sites:visit',
  '/funder/programmes/:programmeId/reporters:visit',
  '/funder/programmes/:programmeId/reporters/:reporterId/assignees:visit',
  '/funder/programmes:visit',
  '/funder/programmes/:visit',
  '/funder/programmes/create:edit',
  '/funder/programmes/:programmeId:visit',
  '/funder/exports:visit',
  '/funder/exports/:workspaceId/questions:visit',
  '/funder/exports/:workspaceId/questions/:type/:typeId:visit',
  '/funder/exports/profile-data:visit',
  '/funder/exports/school-data:visit',
  '/funder/exports/programme-stats:visit',
  '/funder/reports:visit',
  // '/funder/reports/create:visit',
  '/funder/reports/create-link:visit',
  '/funder/reports/create-report:visit',
  '/funder/reports/create-template:visit',
  '/funder/reports/:reportId:visit',

  '/funder/reports/templates:visit',
  '/funder/reports/create-template:visit',
  '/funder/reports/templates/:templateId:visit',

  '/funder/admin:visit',
  `/funder/manage/insights:visit`,
  `/funder/manage/insights/create-new:visit`,
  `/funder/manage/insights/:insightId:visit`,
  `/funder/manage/insights/:insightId/users:visit`,

  // admin templates
  `/admin/templates:visit`,
  `/admin/templates/create-new:visit`,
  `/admin/templates/:templateId:visit`,

  // portal owner routes
  ...FUNDER_OWNER_PLANS['ENTERPRISE'].static,
  ...INSTITUTION_OWNER_PLANS['ENTERPRISE'].static,
  ...SERVICE_PROVIDER_OWNER_PLANS['ENTERPRISE'].static,
];

export const ADMIN_PLANS = {
  static: fullAdminRoutes,
};

export const SUPER_ADMIN_PLANS = {
  static: fullSuperAdminRoutes,
};
